module.exports = __webpack_public_path__ + "static/media/asignatura3.81200c7b.png";